import { LayoutDashboard, LogOut, Package, Settings, User } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type HeaderAuthView = 'signin' | 'signup'

type NavigateAccountAction = {
  key: string
  label: string
  icon: LucideIcon
  actionType: 'navigate'
  href: string
  requiresAdmin?: boolean
  separatorBefore?: boolean
  separatorAfter?: boolean
  destructive?: false
}

type LogoutAccountAction = {
  key: string
  label: string
  icon: LucideIcon
  actionType: 'logout'
  requiresAdmin?: boolean
  separatorBefore?: boolean
  separatorAfter?: boolean
  destructive: true
}

export type AccountAction = NavigateAccountAction | LogoutAccountAction

const ACCOUNT_ACTIONS: AccountAction[] = [
  {
    key: 'admin',
    label: 'Admin Panel',
    icon: LayoutDashboard,
    actionType: 'navigate',
    href: '/admin',
    requiresAdmin: true,
    separatorAfter: true,
  },
  {
    key: 'account',
    label: 'My Account',
    icon: User,
    actionType: 'navigate',
    href: '/account',
  },
  {
    key: 'orders',
    label: 'My Orders',
    icon: Package,
    actionType: 'navigate',
    href: '/account/orders',
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: Settings,
    actionType: 'navigate',
    href: '/account/settings',
  },
  {
    key: 'signout',
    label: 'Sign Out',
    icon: LogOut,
    actionType: 'logout',
    separatorBefore: true,
    destructive: true,
  },
]

export function resolveDisplayName(displayName?: string | null, email?: string | null) {
  return displayName || email?.split('@')[0] || 'User'
}

export function buildAuthHref(
  pathname: string,
  searchParams: URLSearchParams,
  authView: HeaderAuthView
) {
  const params = new URLSearchParams(searchParams.toString())
  params.set('auth', authView)
  const query = params.toString()
  return query ? `${pathname}?${query}` : pathname
}

export function getAccountActions(isAdmin: boolean) {
  return ACCOUNT_ACTIONS.filter(action => !action.requiresAdmin || isAdmin)
}
